import {types} from './types';

const initialState = {
    view: {
        bonus_name: '',
        template: '₽',
        bonus_start: '',
        bonus_end: '',
        max_activation_time: '',
        fix_size_bonus: '',
        wager: 0,
        max_time_roleplaying: 168,
        percent: 100,
        min_bet: 0,
        max_bet: 1000,
        min_balance_close_bonus: 0,
        max_sum_bonus: '',
    },
    list: [],
}

export function bonusesReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_VIEW_BONUSES:
            return { ...state, view: action.payload};
        case types.SET_LIST:
            return { ...state, list: action.payload};
        default:
            return state
    }
}